import React from "react";
import {
  Box,
  Flex,
  Text,
  useColorModeValue,
  SimpleGrid,
  Icon,
} from "@chakra-ui/react";
import { useHistory } from "react-router-dom";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import { FaBell, FaExclamationTriangle } from "react-icons/fa"; // آیکون‌های متناسب با هشدار

const Alerts = () => {
  const history = useHistory();
  
  // رنگ‌بندی‌های چاکرا
  const textColor = useColorModeValue("gray.700", "white");
  const boxBg = useColorModeValue("white", "gray.800");
  const cardShadow = useColorModeValue("md", "dark-lg");
  const descColor = useColorModeValue("gray.500", "gray.400");

  const actionBoxes = [
    {
      title: "اخطارهای قیمتی (اختلاف بیش از ۱۰٪)",
      description: "بررسی محصولاتی که قیمت ما با قیمت رقیب اختلاف فاحشی دارد و نیاز به اصلاح دارد.",
      icon: FaExclamationTriangle,
      color: "red.500",
      path: "/admin/alerts/price-differences", 
    },
  ];

  return (
    <Flex direction="column" pt={{ base: "120px", md: "75px" }}>
      <Card>
        <CardHeader
          p="6px 0px 22px 0px"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
        >
          <Flex align="center" gap={2}>
            <FaBell size={20} color="orange" />
            <Text fontSize="xl" color={textColor} fontWeight="bold">
              سیستم هشدارها (Alerts)
            </Text>
          </Flex>
        </CardHeader>

        <Box px={6} pb={6}>
          <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={6} dir="rtl">
            {actionBoxes.map((box, idx) => (
              <Box
                key={idx}
                p={6}
                bg={boxBg}
                borderRadius="xl"
                boxShadow={cardShadow}
                cursor="pointer"
                _hover={{
                  boxShadow: "lg",
                  transform: "translateY(-4px)",
                }}
                transition="all 0.2s ease-in-out"
                onClick={() => history.push(box.path)} 
              >
                <Flex direction="column" align="center" textAlign="center">
                  <Icon as={box.icon} boxSize={8} mb={3} color={box.color} />
                  <Text fontWeight="bold" fontSize="lg" mb={1} color={textColor}>
                    {box.title}
                  </Text>
                  <Text fontSize="sm" color={descColor}>
                    {box.description}
                  </Text>
                </Flex>
              </Box>
            ))}
          </SimpleGrid>
        </Box>
      </Card>
    </Flex>
  );
};

export default Alerts;